export default __webpack_public_path__ + "static/media/temu.94c8cc39.svg";